var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.size),attrs:{"id":"bar"}},[_c('e-charts',{staticStyle:{"top":"55px"},attrs:{"size":_vm.size,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }